import {React} from 'react'
import Helmet from '../components/Helmet/Helmet'
import { Container,Row,Col } from 'react-bootstrap'
import heroImg from '../assets/images/hero-img.webp'
import {Link} from 'react-router-dom'
import {motion} from 'framer-motion'
import Services from '../services/Services'
import AllProduct from '../All-Products/AllProducts'


import '../assets/style/home.css'
const Home = () => {
  
  const year = new Date().getFullYear()

  return (
    <>
      <Helmet title="Home"/>
      <section className='hero__section'>
        <Container>
          <Row>
            <Col lang='6' md='6'>
              <div className="hero__content">
                <p className='hero__subtitle'>
                  Trending Product In {year}
                </p>
                <h2>
                  Make Your Interior More Minimalistic & Modern
                </h2>
                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Debitis ducimus et odit quod nam aspernatur, hic dignissimos maiores rerum corporis.</p>
                  <Link to='/shop'>
                    <motion.button whileTap={{scale:1.2}} className="buy__btn">
                      Shop Now
                    </motion.button>
                  </Link>
              </div>
            </Col>

            <Col lg='6' md='6'>
              <div className="hero__img">
                <img src={heroImg} alt="hero" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Services />
      <AllProduct />

    </>
  )
}

export default Home